import { render } from "./TTMWellForm.vue?vue&type=template&id=63ff426a"
import script from "./TTMWellForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TTMWellForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/forms/TTMWellForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "63ff426a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('63ff426a', __exports__)) {
    console.log('reload')
    api.reload('63ff426a', __exports__)
  }
  
  module.hot.accept("./TTMWellForm.vue?vue&type=template&id=63ff426a", () => {
    console.log('re-render')
    api.rerender('63ff426a', render)
  })

}


export default __exports__